import React from 'react';
import filterIcon from '../../assets/img/feed-imgs/center/popular/filter.svg'
import sortingIcon from '../../assets/img/feed-imgs/center/popular/sort.svg'

const FilterAndShort = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center">
                <img className="me-2" src={filterIcon} alt='' />
                <span className="center_txt cursor-pointer">Filter</span>
            </div>
            <div className="d-flex justify-content-center align-items-center cursor-pointer">
                <img className="me-2" src={sortingIcon} alt='' />
                <span className="center_txt">Sort</span>
            </div>
        </>
    );
};

export default FilterAndShort;